<template>
  <v-card flat>
    <div>
      <v-subheader v-if="historyIsActive">
        HISTORIAL

        <v-spacer></v-spacer>

        <v-btn icon x-small width="24" height="24" color="grey " class="elevation-0" @click="closeHistory">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-subheader>
    </div>
    <v-list dense two-line color="rgba(0,0,0,0)" height="54vh" v-if="!isLoading">
      <vuescroll
        ref="scroll"
        :ops="{
          bar: {
            background: '#bacfcec0',
            keepShow: true,
          },
        }"
        @handle-scroll="onScroll"
      >
        <v-list-item-group v-model="selected" active-class="blue lighten-4" three-line>
          <template v-for="item in filteredList">
            <v-list-item
              :disabled="isLoading"
              three-line
              :key="item.id"
              class="pl-3"
              :value="item.id"
              @click="chatPreview(item, false)"
            >
              <v-list-item-avatar
                v-if="!historyIsActive"
                size="30"
                :color="$vuetify.theme.dark ? 'blue-grey darken-4' : 'blue-grey lighten-5'"
                class="mt-2"
              >
                <v-icon
                  size="24"
                  v-if="item.typeTicketId === 1 || item.typeTicketId === 4"
                  color="green green-darken-2"
                >
                  mdi-whatsapp
                </v-icon>
                <v-icon size="30" v-else-if="item.typeTicketId === 2" color="blue-grey">
                  mdi-web
                </v-icon>
                <img
                  style="width: 24px !important"
                  v-else-if="item.typeTicketId === 3"
                  src="@/assets/icons/telegram.png"
                  alt="Telegram icono"
                />
                <v-icon size="24" v-else-if="item.typeTicketId === 5" color="pink">
                  mdi-instagram
                </v-icon>
                <v-icon size="24" v-else-if="item.typeTicketId === 6" color="blue">
                  mdi-whatsapp
                </v-icon>
                <v-icon size="24" v-else-if="item.typeTicketId === 7" color="blue">
                  mdi-facebook-messenger
                </v-icon>
                <!-- <v-icon color="blue-grey" v-else>mdi-account</v-icon> -->
              </v-list-item-avatar>

              <template>
                <v-list-item-content>
                  <v-list-item-title class="custom-list-item-title">
                    <span class="d-block">
                      <v-icon v-if="item.queue != null" small color="">
                        mdi-human-queue
                      </v-icon>
                      <template v-if="item.contacts">
                        <span>
                          <!-- {{ item.contacts.name + " (" + item.contacts.whatsapp + ")" }} -->
                          {{ item.contacts.name }}
                        </span>
                        <small class="grey--text" style="float: right" :title="item.created_at">
                          {{ formatDate(item.created_at) }}
                        </small>
                      </template>
                      <template v-else>
                        Nombre no definido
                      </template>
                    </span>

                    <small v-if="historyIsActive">
                      {{ dateFormat(item.created_at) }}
                    </small>
                  </v-list-item-title>

                  <v-list-item-subtitle class="acortador">
                    {{ item.last_message != null ? item.last_message.body : "" }}
                  </v-list-item-subtitle>

                  <v-list-item-subtitle class="grey--text ligthen-5">
                    <template v-if="item.config">
                      <small>
                        {{ item.config.name + " (" + item.config.number + ")" }}
                      </small>
                    </template>
                    <template v-else>
                      No definido
                    </template>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>

              <v-list-item-action v-if="item.unreadMessages > 0">
                <v-btn fab x-small width="24" height="24" color="success" class="elevation-0">
                  <span class="text-medium">
                    {{ item.unreadMessages }}
                  </span>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-list-item-group>
        <v-list-item v-if="chatList.length < totalChats">
          <v-btn block text color="primary" :loading="isLoadingMore" @click="$emit('load:more')">
            Cargar más
          </v-btn>
        </v-list-item>
      </vuescroll>
    </v-list>

    <div style="height:54vh" v-else>
      <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
      <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
      <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
      <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
      <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
      <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
      <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
    </div>
  </v-card>
</template>

<script>
import moment from "moment";
moment.locale("es");
import vuescroll from "vuescroll";
import { dateFormat } from "./utils";
export default {
  components: { vuescroll },
  props: {
    isLoading: {
      type: Boolean,
    },
    historyIsActive: {
      type: Boolean,
    },
    totalChats: {
      type: Number,
    },
    chatList: {
      type: Array,
    },
    search: {
      type: String,
    },
    isLoadingMore: {
      type: Boolean,
    },
  },

  data: () => ({
    selected: null,
  }),

  computed: {
    Role() {
      return this.$store.getters["passport/GET_ROLE"];
    },

    filteredList() {
      if (this.search === "") {
        return this.chatList;
      } else {
        return this.chatList.filter((item) => {
          if (item.contacts && typeof item.contacts.name === "string" && typeof item.contacts.whatsapp === "string") {
            return (
              item.contacts.name.toLowerCase().includes(this.search.toLowerCase()) ||
              item.contacts.whatsapp.toLowerCase().includes(this.search.toLowerCase())
            );
          }
          return false;
        });
      }
    },
  },

  watch: {
    chatList(val) {
      if (val.length > 0 && this.$route.query.chatId) {
        this.autoSelectChat();
      }
    },
  },

  methods: {
    onScroll(vertical) {
      const { scrollTop, clientHeight, scrollHeight } = vertical;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        this.$emit("load:more");
      }
    },

    chatPreview(item, newMessage) {
      this.$emit("chat:preview", item, newMessage);
    },

    closeHistory() {
      this.$emit("close:history");
    },

    formatDate(date) {
      return moment(date).fromNow();
    },

    autoSelectChat() {
      const chatId = this.$route.query.chatId;
      const chat = this.filteredList.find((chat) => +chat.id === +chatId);
      if (chat && this.selected !== chat.id) {
        this.selected = chat.id;
        this.$emit("chat:preview", chat, false);
      }
    },

    dateFormat,
  },
};
</script>

<style>
.acortador {
  white-space: nowrap !important; /* Evita el salto de línea */
  overflow: hidden !important; /* Oculta el texto que excede el tamaño del contenedor */
  text-overflow: ellipsis !important; /* Agrega los tres puntos suspensivos */
  width: 20px !important; /* Define el ancho máximo del contenedor para mostrar el efecto de acortamiento */
}
</style>
